export enum MerchantType {
  Health = 'Health',
  Enterprise = 'Enterprise',
  EnterpriseLarge = 'EnterpriseLarge',
  SMB = 'Smb',
}
